// One height in the two forms Tailwind can scan for. Kept out of the header's
// "use client" module: a server component importing a plain value from one gets
// a client-reference stub, not the string.
export const HERO_HEADER_HEIGHT =
  "[--nav-h-from:5rem] lg:[--nav-h-from:5.5rem]";
export const HERO_HEADER_SPACER = "pt-20 lg:pt-22";
